/* eslint-disable max-len */
/* eslint-disable no-undef */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import randomUUIDGenerator from '../../src/utils/randomUUIDGenerator.js';
import { CkeditorConstants } from '../../src/utils';

const { htmlAttributes: { NUMBERED_CITATION_CLASS } } = CkeditorConstants;
export default class CopyCitationReferenceEditing extends Plugin {
  init() {
    const editor = this.editor;
    const editingView = editor.editing.view;
    const multipleRefs = [];
    let citationCount;
    let refsToBeReOrderedInRightHandPanel = []
    let isCopiedRefAlreadyRenumbered;
    let shouldRunReOrder = false;
    const parser = new DOMParser();

    editingView.document.on('clipboardInput', (evt, data) => {
      if (editor.isReadOnly) {
        return;
      }
      const dataTransfer = data.dataTransfer;
      const content = dataTransfer.getData('text/html');
      const parsedContent = parser.parseFromString(content, 'text/html');
      parsedContent.body.querySelectorAll('.numbered-citation').forEach(ele => {
        multipleRefs.push(ele);
      });

      const doc = this.editor.model.document;
      doc.on('change:data', () => {
        let citationsToBeReOrdered = [];
        if (multipleRefs.length > 0) {
          shouldRunReOrder = true;
          for (const eachRef of multipleRefs) {
            if (eachRef.getAttribute('data-parentcitation')) {
              citationsToBeReOrdered.push({
                id: eachRef.getAttribute('data-parentcitation'),
                citationCount: eachRef.getAttribute('data-citationcount'),
                currentCopiedRefId: eachRef.getAttribute('id')
              })
            } else {
              citationsToBeReOrdered.push({
                id: eachRef.getAttribute('id'),
                citationCount: eachRef.getAttribute('data-citationcount'),
                currentCopiedRefId: null
              })
            }
          }
        }

        if (shouldRunReOrder) {
          multipleRefs.length = 0;
          const range = this.editor.model.createRangeIn(this.editor.model.document.getRoot());
          if (citationsToBeReOrdered.length > 0) {
            const baseHrefId = this.editor?.baseHrefId?.concat('#') || '';
            const baseHrefPathUrl = this.editor?.baseHrefPathUrl?.concat('/') || '';
            for (const [index, eachCitationToDelete] of citationsToBeReOrdered.entries()) {
              const foundItems = [];
              const newCopiedItems = [];
              for (const item of range.getItems({ ignoreElementEnd: true })) {
                const editingRootDomElement = editor.editing.view.domRoots.get('main');
                citationCount = editingRootDomElement.querySelector(`[id='${eachCitationToDelete.id}']`)?.getAttribute?.('data-citationcount');
                isCopiedRefAlreadyRenumbered = (citationCount?.toString() === eachCitationToDelete.citationCount.toString());
                const countCitation = item?.getAttribute?.('data-citationcount')?.toString()
                const delCountCitation = eachCitationToDelete.citationCount.toString()
                if (isCopiedRefAlreadyRenumbered) {
                  if (countCitation === delCountCitation) {
                    foundItems.push(item);
                  }
                } else {
                  if (countCitation === delCountCitation) {
                    foundItems.push(item);
                  }
                  if (countCitation === citationCount?.toString()) {
                    newCopiedItems.push(item);
                  }
                }
              }

              let id;
              let currentrefsToBeReOrderedInRightHandPanel = {
                oldFirstRefId: "",
                newFirstCitedRefId: "",
                subsequentRefIds: [],
                isCopiedRefAlreadyRenumbered: true,
                citationCount: "0"
              };
              if (isCopiedRefAlreadyRenumbered) {
                for (let i = 0; i < foundItems.length; i++) {
                  editor.model.change((writer) => {
                    if (foundItems[0].getAttribute('id') !== eachCitationToDelete.id) { /** When subsequent cited ref gets pasted to the top */
                      if (i === 0) {
                        if (foundItems[0].getAttribute('data-parentcitation')) {
                          writer.removeAttribute('data-parentcitation', foundItems[0]);
                        }
                        id = randomUUIDGenerator();
                        const aboutAttribute = `${baseHrefPathUrl}${baseHrefId}${id}`;
                        writer.setAttributes({
                          id,
                          'about': aboutAttribute,
                        }, foundItems[0]);
                        currentrefsToBeReOrderedInRightHandPanel.oldFirstRefId = eachCitationToDelete.id;
                        currentrefsToBeReOrderedInRightHandPanel.newFirstCitedRefId = id;
                        refsToBeReOrderedInRightHandPanel.push(currentrefsToBeReOrderedInRightHandPanel)
                      } else {
                        writer.setAttribute('data-parentcitation', foundItems[0].getAttribute('id'), foundItems[i]);
                        const subsequentRefID = foundItems[i].getAttribute('id')
                        if (!refsToBeReOrderedInRightHandPanel[index].subsequentRefIds.includes(subsequentRefID)) {
                          refsToBeReOrderedInRightHandPanel[index].subsequentRefIds.push(subsequentRefID)
                        }
                      }
                    } else if (foundItems[0].getAttribute('id') === eachCitationToDelete.id) { /** When first cited ref gets pasted to the top */
                      if (i !== 0) {
                        let id = randomUUIDGenerator();
                        const indexOfCopiedSubseqRef = foundItems.findIndex((item) => item.getAttribute('id') === eachCitationToDelete.currentCopiedRefId)
                        if ((foundItems[i].getAttribute('id') === eachCitationToDelete.id) || (i !== indexOfCopiedSubseqRef && foundItems[i].getAttribute('id') === eachCitationToDelete.currentCopiedRefId)) {
                          const aboutAttribute = `${baseHrefPathUrl}${baseHrefId}${id}`;
                          writer.setAttributes({
                            id,
                            'about': aboutAttribute,
                            'data-parentcitation': eachCitationToDelete.id,
                          }, foundItems[i]
                          );
                        }
                        currentrefsToBeReOrderedInRightHandPanel.oldFirstRefId = eachCitationToDelete.id;
                        currentrefsToBeReOrderedInRightHandPanel.newFirstCitedRefId = eachCitationToDelete.id;
                        if (i === 1) {
                          refsToBeReOrderedInRightHandPanel.push(currentrefsToBeReOrderedInRightHandPanel)
                        }
                        const subsequentRefID = foundItems[i].getAttribute('id')
                        if (!refsToBeReOrderedInRightHandPanel[index].subsequentRefIds.includes(subsequentRefID)) {
                          refsToBeReOrderedInRightHandPanel[index].subsequentRefIds.push(subsequentRefID)
                        }
                      }
                    }
                  })
                }
              } else { /** When user pastes the same copied multiple times after reorder */
                for (let i = 0; i < foundItems.length; i++) {
                  editor.model.change((writer) => {
                    let indexToRestrictDuplicateArr;
                    if (foundItems[i].getAttribute('id') === eachCitationToDelete.id && newCopiedItems[0]?.getAttribute?.('id') === eachCitationToDelete.id) {
                      let id = randomUUIDGenerator();
                      indexToRestrictDuplicateArr = i;
                      const aboutAttribute = `${baseHrefPathUrl}${baseHrefId}${id}`;
                      writer.setAttributes({
                        id,
                        'about': aboutAttribute,
                        'resource': newCopiedItems[0]?.getAttribute?.('resource'),
                        'data-citationcount': newCopiedItems[0]?.getAttribute?.('data-citationcount'),
                        'data-parentcitation': newCopiedItems[0]?.getAttribute?.('id')
                      }, foundItems[i]
                      );
                    }

                    const currentFirstAndSubRef = []
                    for (const item of range.getItems({ ignoreElementEnd: true })) {
                      if (item?.getAttribute?.('data-citationcount')?.toString() === citationCount?.toString()) {
                        currentFirstAndSubRef.push(item);
                      }
                    }

                    if (currentFirstAndSubRef[0]?.getAttribute?.('id') !== eachCitationToDelete.id) {
                      let idToReplace = currentFirstAndSubRef[0]?.getAttribute?.('id');
                      for (let i = 0; i < currentFirstAndSubRef.length; i++) {
                        if (i == 0) {
                          if (currentFirstAndSubRef[0].getAttribute('data-parentcitation')) {
                            writer.removeAttribute('data-parentcitation', currentFirstAndSubRef[0]);
                            writer.setAttribute('id', newCopiedItems[0]?.getAttribute?.('id'), currentFirstAndSubRef[0])
                            currentrefsToBeReOrderedInRightHandPanel.oldFirstRefId = idToReplace;
                            currentrefsToBeReOrderedInRightHandPanel.newFirstCitedRefId = newCopiedItems[0]?.getAttribute?.('id');
                            currentrefsToBeReOrderedInRightHandPanel.isCopiedRefAlreadyRenumbered = false;
                            currentrefsToBeReOrderedInRightHandPanel.citationCount = newCopiedItems[0]?.getAttribute?.('data-citationcount').toString();
                            refsToBeReOrderedInRightHandPanel.push(currentrefsToBeReOrderedInRightHandPanel)
                          }
                        } else if (currentFirstAndSubRef[i]?.getAttribute('id') === eachCitationToDelete.id) {
                          let id = randomUUIDGenerator();
                          const aboutAttribute = `${baseHrefPathUrl}${baseHrefId}${id}`;
                          writer.setAttributes({
                            id,
                            'about': aboutAttribute,
                            'data-parentcitation': newCopiedItems[0]?.getAttribute?.('id'),
                            'resource': newCopiedItems[0]?.getAttribute?.('resource')
                          }, currentFirstAndSubRef[i]
                          );
                        }
                      }
                    } else {
                      currentrefsToBeReOrderedInRightHandPanel.oldFirstRefId = eachCitationToDelete.id;
                      currentrefsToBeReOrderedInRightHandPanel.newFirstCitedRefId = eachCitationToDelete.id;
                      currentrefsToBeReOrderedInRightHandPanel.isCopiedRefAlreadyRenumbered = false;
                      currentrefsToBeReOrderedInRightHandPanel.citationCount = currentFirstAndSubRef[0]?.getAttribute?.('data-citationcount')?.toString();
                      refsToBeReOrderedInRightHandPanel.push(currentrefsToBeReOrderedInRightHandPanel)
                    }
                  });
                }
              }
            }
          }
          citationsToBeReOrdered.length = 0;
          this.editor.execute("renumbercitations");
          const docrange = this.editor.model.createRangeIn(this.editor.model.document.getRoot());
          const firstCited = [...docrange.getItems({ ignoreElementEnd: true })]
            .filter(item => item?.name === "numberedcitation" &&
              !item?.getAttribute?.('data-parentcitation'))
            .map(item => ({
              resource: item.getAttribute('resource'),
              referencedBy: []
            }));
          firstCited.forEach((firstCitedItem) => {
            for (const item of docrange.getItems({ ignoreElementEnd: true })) {
              if (item?.name === "numberedcitation" && item?.getAttribute?.('resource') === firstCitedItem.resource) {
                firstCitedItem.referencedBy.push(item.getAttribute('id'))
              }
            }
          });
          this.editor.fire("pasteCitationRefsInDocument", { citationsPanelReOrderData: firstCited });
          refsToBeReOrderedInRightHandPanel = [];
          this.editor.execute('numberedcitationconverter')
          shouldRunReOrder = false;
        }
      }, { priority: 'high' });
    }, { priority: 'highest' });
  }
}
